//import React, { useState, useEffect } from 'react';
//import axios from 'axios';
//import { Link } from "react-router-dom";
//import HoaNavbar from "../HoaNavbar/HoaNavbar";
//import HoaFooter from "../HoaFooter/HoaFooter";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { faSync } from "@fortawesome/free-solid-svg-icons";
//import { API_URL } from '../../apiConfig';
//import LoadingComman from '../Loading/LoadingCommon';
//import PhoneInput from 'react-phone-input-2';
//import 'react-phone-input-2/lib/style.css';

//function MemberOnboard() {
//  const [selectedCountryId, setSelectedCountryId] = useState(0);
//  const [loadingComman, setLoadingComman] = useState(false);
//  const [acceptTerms, setAcceptTerms] = useState(false);
//  const [formData, setFormData] = useState({
//    addressDto: {
//      activeStatus: true,
//      address: "",
//      addressId: 0,
//      city: "",
//      countryId: 0,
//      stateId: 0,
//      zipCode: 0
//    },
//    boardMemberRole: "",
//    clientDto: {
//      activestatus: true,
//      clientid: 0,
//      communityid: 0,
//      displayname: "",
//      numberofhouses: 0,
//      userid: 0
//    },
//    communityCode: "",
//    contractCode: "",
//    userDto: {
//      activeStatus: false,
//      emailId: "",
//      emailIdIsVerified: true,
//      firstName: "",
//      isClient: true,
//      lastLogin: "",
//      lastName: "",
//      middleName: "",
//      mobileIsVerified: true,
//      mobileNumber: "",
//      otp: 0,
//      password: "",
//      roleId: 1003,
//      userId: 0,
//      createdDate: new Date().toISOString(),
//      modifiedById: null,
//      modifiedDate: new Date().toISOString(),
//      userProfileUrl: ""
//    }
//  });

//  const handlePhoneNumberChange = (value) => {
//    setFormData((prevState) => ({
//      ...prevState,
//      userDto: {
//        ...prevState.userDto,
//        mobileNumber: value,
//      },
//    }));

//    // Clear the phone number error when user starts typing
//    setErrors((prevErrors) => ({
//      ...prevErrors,
//      mobileNumber: value ? "" : prevErrors.mobileNumber,
//    }));
//  };

//  const [communityCode, setCommunityCode] = useState("");
//  const [communityAddressData, setCommunityAddressData] = useState(null);
//  console.log(communityAddressData);

//  const handleCommunityCode = (e) => {
//    const newCommunityCode = e.target.value;
//    setCommunityCode(newCommunityCode);
//    setFormData((prevFormData) => ({
//      ...prevFormData,
//      communityCode: newCommunityCode,
//    }));
//    setErrors((prevErrors) => ({
//      ...prevErrors,
//      communityCode: newCommunityCode ? "" : prevErrors.communityCode,
//    }));
//  };

//  useEffect(() => {
//    if (communityCode) {
//      fetchcommunityAddressData(communityCode);
//    }
//  }, [communityCode]);

//  const fetchcommunityAddressData = async (communityCode) => {
//    try {
//      const response = await fetch(`${API_URL}/public/community/getByCommunityCodeForUser/${communityCode}`);
//      if (response.ok) {
//        const data = await response.json();
//        setCommunityAddressData(data);
//        const addressFormDataUpdate = {
//          addressDto: {
//            activeStatus: true,
//            address: "",
//            addressId: 0,
//            city: data.city,
//            countryId: data.countryId,
//            stateId: data.stateId,
//            zipCode: data.zipCode

//          }

//        };
//        setSelectedCountryId(data.countryId);
//        setFormData((prevFormData) => ({
//          ...prevFormData,
//          addressDto: addressFormDataUpdate.addressDto,
//        }));
//      } else {
//        console.error('Failed to fetch Community Address data');
//      }
//    } catch (error) {
//      console.error('Error fetching Community Address  data:', error);
//    }
//  };

//  const [errors, setErrors] = useState({});
//  const [verified, setVerified] = useState(false);
//  const [captchaValid, setCaptchaValid] = useState(false);
//  const [userInput, setUserInput] = useState("");
//  const [generatedCaptcha, setGeneratedCaptcha] = useState(generateCaptcha());
//  const [captchaErrorMessage, setCaptchaErrorMessage] = useState(null);
//  const [countryData, setCountryData] = useState([]);
//  const [stateData, setStateData] = useState([]);

//  useEffect(() => {
//    axios.get(`${API_URL}/public/country/getAll`)
//      .then(response => {
//        setCountryData(response.data);
//      })
//      .catch(error => {
//        console.error('Error fetching countries:', error);
//      });
//  }, []);

//  useEffect(() => {
//    axios.get(`${API_URL}/public/state/getAll`)
//      .then(response => {
//        setStateData(response.data);
//      })
//      .catch(error => {
//        console.error('Error fetching states:', error);
//      });
//  }, []);

//  useEffect(() => {
//    setFormData(prevState => ({
//      ...prevState,
//      clientDto: {
//        ...prevState.clientDto,
//        displayname: prevState.userDto.firstName
//      }
//    }));
//  }, [formData.userDto.firstName]);

//  function generateCaptcha() {
//    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
//    let captcha = "";
//    for (let i = 0; i < 6; i++) {
//      const randomIndex = Math.floor(Math.random() * characters.length);
//      captcha += characters[randomIndex];
//    }
//    return captcha;
//  }

//  function handleInputChange(event) {
//    const value = event.target.value;
//    setUserInput(value);

//    // Clear the captcha error when user starts typing
//    setErrors((prevErrors) => ({
//      ...prevErrors,
//      captcha: value ? "" : prevErrors.captcha,
//    }));
//  }

//  function regenerateCaptcha() {
//    setGeneratedCaptcha(generateCaptcha());
//  }

//  const validateForm = async () => {
//    let isValid = true;
//    const newErrors = {};

//    // First Name validation
//    if (!formData.userDto.firstName || !formData.userDto.firstName.trim()) {
//      newErrors.firstName = "Please provide your first name.";
//      isValid = false;
//    }

//    // Last Name validation
//    if (!formData.userDto.lastName || !formData.userDto.lastName.trim()) {
//      newErrors.lastName = "Please provide your last name.";
//      isValid = false;
//    }

//    // Email validation
//    if (!formData.userDto.emailId || !formData.userDto.emailId.trim()) {
//      newErrors.emailId = "Please provide your email address.";
//      isValid = false;
//    } else if (!/\S+@\S+\.\S+/.test(formData.userDto.emailId)) {
//      newErrors.emailId = "Please provide a valid email address.";
//      isValid = false;
//    } else {
//      const emailId = formData.userDto.emailId;
//      const isEmailAvailable = await handleEmailCheck(emailId);

//      if (!isEmailAvailable) {
//      } else {
//        newErrors.emailId = 'Email is already taken';
//        isValid = false;
//      }
//    }

//    // Residential address validation
//    if (!formData.addressDto.address || !formData.addressDto.address.trim()) {
//      newErrors.address = "Please provide your residential address.";
//      isValid = false;
//    }

//    // Country validation
//    if (!formData.addressDto.countryId) {
//      newErrors.countryId = "Please select your country name.";
//      isValid = false;
//    }

//    // State validation
//    if (!formData.addressDto.stateId) {
//      newErrors.stateId = "Please select your state name.";
//      isValid = false;
//    }

//    // Mobile number validation
//    if (
//      !formData.userDto.mobileNumber ||
//      formData.userDto.mobileNumber.length < 10 ||
//      !/^\d+$/.test(formData.userDto.mobileNumber)
//    ) {
//      newErrors.mobileNumber = "Please enter a valid phone number.";
//      isValid = false;
//    }

//    // City validation
//    if (!formData.addressDto.city || !formData.addressDto.city.trim()) {
//      newErrors.city = "Please provide your city.";
//      isValid = false;
//    }

//    // Zip code validation
//    if (!formData.addressDto.zipCode || !String(formData.addressDto.zipCode).trim()) {
//      newErrors.zipCode = "Please provide your zip code.";
//      isValid = false;
//    }

//    // Community code validation
//    if (!formData.communityCode || !formData.communityCode.trim()) {
//      newErrors.communityCode = "Please provide a valid CommunityCode.";
//      isValid = false;
//    } else if (/[)( _+":;'.,]/.test(formData.communityCode)) {
//      newErrors.communityCode = "CommunityCode cannot contain spaces or invalid characters.";
//      isValid = false;
//    }

//    // Captcha validation
//    if (!userInput) {
//      newErrors.captcha = "Please fill in the captcha.";
//      isValid = false;
//    } else if (userInput !== generatedCaptcha) {
//      newErrors.captcha = "Captcha is incorrect.";
//      isValid = false;
//    }

//    // Terms and conditions validation
//    if (!acceptTerms) {
//      newErrors.acceptTerms = "You must accept the terms and conditions.";
//      isValid = false;
//    }

//    // Set the validation errors to state
//    setErrors(newErrors);
//    console.log(newErrors);

//    // Return true if there are no errors (all validations passed), false otherwise
//    return isValid;
//  };

//  const handleEmailCheck = async (emailId) => {
//    console.log("Checking email availability...");

//    try {

//      const response = await axios.get(`${API_URL}/user/check/email?emailId=${emailId} `);
//      if (response.status === 200) {
//        return false;
//      }
//      return true;
//    } catch (error) {
//      console.error('Error checking email:', error);
//      return true;
//    }
//  };

//  const handleChange = (e) => {
//    const { name, value } = e.target;

//    setFormData(prevState => {
//      const updatedFormData = { ...prevState };

//      const fieldPath = name.split('.');
//      if (fieldPath.length === 2) {
//        const [section, field] = fieldPath;
//        updatedFormData[section][field] = (field === 'countryId' || field === 'stateId') ? parseInt(value, 10) : value;
//      } else {
//        updatedFormData[name] = value;
//      }

//      return updatedFormData;
//    });

//    setErrors(prevErrors => {
//      const updatedErrors = { ...prevErrors };

//      const errorKey = name.split('.').pop();

//      if (updatedErrors[errorKey]) {
//        delete updatedErrors[errorKey];
//      }

//      return updatedErrors;
//    });

//    if (name === 'addressDto.countryId') {
//      setSelectedCountryId(parseInt(value, 10));
//    }
//  };

//  const handleSubmit = async (e) => {
//    e.preventDefault();
//    console.log('Form submitted:', formData);

//    const isValid = await validateForm();

//    if (isValid) {
//      setLoadingComman(true);
//      try {
//        const response = await axios.post(`${API_URL}/public/clientRequest/add`, formData);
//        console.log('Form submitted successfully:', response.data);
//        setFormData({});
//        alert("Registered Successfully");
//        handleCancel();
//        window.location.href = '/';
//      } catch (error) {
//        console.error('Error submitting form:', error);
//      } finally {
//        setLoadingComman(false);
//      }
//    } else {
//      setLoadingComman(false);
//    }
//  };

//  const handleKeyPress = (e) => {
//    if (!/[0-9]/.test(e.key)) {
//      e.preventDefault();
//    }
//  };
//  const displayValue = (value) => {
//    return value === 0 ? "" : value;
//  };

//  const handleCancel = () => {
//    setFormData({
//      addressDto: {
//        activeStatus: true,
//        address: "",
//        addressId: 0,
//        city: "",
//        countryId: 0,
//        stateId: 0,
//        zipCode: 0
//      },
//      clientDto: {
//        activeStatus: true,
//        clientid: 0,
//        communityid: 0,
//        displayname: "",
//        numberofhouses: 0,
//        userid: 0
//      },
//      communityCode: "",
//      contractCode: "",
//      userDto: {
//        activeStatus: false,
//        emailId: "",
//        emailIdIsVerified: true,
//        firstName: "",
//        isClient: true,
//        lastLogin: "",
//        lastName: "",
//        middleName: "",
//        mobileIsVerified: true,
//        mobileNumber: "",
//        otp: 0,
//        password: "",
//        roleId: 1003,
//        userId: 0,
//        createdDate: new Date().toISOString(),
//        modifiedById: null,
//        modifiedDate: new Date().toISOString(),
//        userProfileUrl: ""
//      }
//    });
//    setErrors({});
//    setUserInput("");
//    setAcceptTerms(false);
//  };

//  return (
//    <>
//      <div className="fixed top-0 w-full z-50">
//        <HoaNavbar />
//      </div>
//      {loadingComman && <LoadingComman />}
//      {!loadingComman && (
//        <div className="mt-[70px] min-h-screen bg-gray-50 py-8">
//          <div className="bg-blue-800 text-white w-[85%] mx-auto my-5 py-5 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.3)] rounded-lg">
//            <div className="w-[85%] mx-auto my-5 flex flex-col gap-5">
//              <div className="flex text-white">
//                <svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 20 20">
//                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//                </svg>
//              </div>
//              <h2 className="text-white text-2xl font-bold">Client Form</h2>
//              <p className="text-base flex gap-2.5 items-center text-white">
//                Please enter your info below. * is mandatory
//              </p>
//            </div>

//            <form onSubmit={handleSubmit}>
//              <div className="w-[85%] mx-auto flex flex-wrap items-start gap-5 py-2.5">
//                <div className="w-full lg:w-[calc(100%-20px)]">
//                  <label htmlFor="communityCode" className="block mb-1 text-white">Community Code*</label>
//                  <input
//                    type="text"
//                    name="communityCode"
//                    id="communityCode"
//                    value={communityCode}
//                    onChange={handleCommunityCode}
//                    className="w-full lg:w-1/2 rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                  />
//                  {errors.communityCode && (
//                    <span className="text-white font-semibold text-base text-center block mt-1">{errors.communityCode}</span>
//                  )}
//                </div>

//                <div className="w-full lg:w-[calc(33.33%-20px)]">
//                  <label htmlFor="firstName" className="block mb-1 text-white">First Name *</label>
//                  <input
//                    type="text"
//                    name="userDto.firstName"
//                    id="firstName"
//                    placeholder="Please Enter"
//                    value={formData.userDto.firstName}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    maxLength={50}
//                  />
//                  {errors.firstName && (
//                    <span className="text-white font-semibold text-base text-center block mt-1">{errors.firstName}</span>
//                  )}
//                </div>

//                <div className="w-full lg:w-[calc(33.33%-20px)]">
//                  <label htmlFor="middleName" className="block mb-1 text-white">Middle Name</label>
//                  <input
//                    type="text"
//                    name="userDto.middleName"
//                    id="middleName"
//                    placeholder="Optional"
//                    value={formData.userDto.middleName}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    maxLength={50}
//                  />
//                </div>

//                <div className="w-full lg:w-[calc(33.33%-20px)]">
//                  <label htmlFor="lastName" className="block mb-1 text-white">Last Name*</label>
//                  <input
//                    type="text"
//                    name="userDto.lastName"
//                    id="lastName"
//                    placeholder="Please Enter"
//                    value={formData.userDto.lastName}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    maxLength={50}
//                  />
//                  {errors.lastName && (
//                    <span className="text-white font-semibold text-base text-center block mt-1">{errors.lastName}</span>
//                  )}
//                </div>

//                <div className="w-full lg:w-[calc(50%-20px)]">
//                  <label htmlFor="mobileNumber" className="block mb-1 text-white">Phone number*</label>
//                  <PhoneInput
//                    placeholder="Enter phone number"
//                    value={formData.userDto.mobileNumber}
//                    onChange={handlePhoneNumberChange}
//                    defaultCountry="US"
//                    containerClass="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none text-black text-base transition-all duration-150 ease-in-out border-none bg-white"
//                    inputClass="phone-input"
//                    country={'us'}
//                    inputStyle={{
//                      width: '100%',
//                      height: '42px',
//                      fontSize: '16px',
//                      borderRadius: '8px',
//                      border: 'none',
//                      outline: 'none',
//                      backgroundColor: 'white',
//                      color: 'black'
//                    }}
//                  />
//                  {errors.mobileNumber && (
//                    <span className="text-white font-semibold text-base text-center block mt-1">{errors.mobileNumber}</span>
//                  )}
//                </div>

//                <div className="w-full lg:w-[calc(50%-20px)]">
//                  <label htmlFor="emailId" className="block mb-1 text-white">Email Address*</label>
//                  <input
//                    type="email"
//                    name="userDto.emailId"
//                    id="emailId"
//                    placeholder="Email Address"
//                    value={formData.userDto.emailId}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    maxLength={100}
//                  />
//                  {errors.emailId && <span className="text-white font-semibold text-base text-center block mt-1">{errors.emailId}</span>}
//                </div>

//                <div className="w-full lg:w-[calc(50%-20px)]">
//                  <label htmlFor="address" className="block mb-1 text-white">Residential Address*</label>
//                  <input
//                    type="text"
//                    name="addressDto.address"
//                    id="address"
//                    placeholder="Residential Address"
//                    value={formData.addressDto.address}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    maxLength={100}
//                  />
//                  {errors.address && <span className="text-white font-semibold text-base text-center block mt-1">{errors.address}</span>}
//                </div>

//                <div className="w-full lg:w-[calc(50%-20px)]">
//                  <label htmlFor="countryId" className="block mb-1 text-white">Country*</label>
//                  <select
//                    id="countryId"
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    name="addressDto.countryId"
//                    value={formData.addressDto.countryId}
//                    onChange={(e) => e.preventDefault()} // Prevent changes
//                  >
//                    <option value="">Filter country</option>
//                    {countryData?.map(country => (
//                      <option key={country.countryid} value={country.countryid}>
//                        {country.countryname}
//                      </option>
//                    ))}
//                  </select>
//                  {errors.countryId && (
//                    <span className="text-white font-semibold text-base text-center block mt-1">{errors.countryId}</span>
//                  )}
//                </div>

//                <div className="w-full lg:w-[calc(50%-20px)]">
//                  <label htmlFor="stateId" className="block mb-1 text-white">State*</label>
//                  <select
//                    id="stateId"
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    name="addressDto.stateId"
//                    value={formData.addressDto.stateId}
//                    onChange={(e) => e.preventDefault()} // Prevent changes
//                  >
//                    <option value="">Filter State</option>
//                    {stateData
//                      .filter(state => state.countryid === selectedCountryId)
//                      .map(state => (
//                        <option key={state.stateid} value={state.stateid}>
//                          {state.statename}
//                        </option>
//                      ))}
//                  </select>
//                  {errors.stateId && (
//                    <span className="text-white font-semibold text-base text-center block mt-1">{errors.stateId}</span>
//                  )}
//                </div>

//                <div className="w-full lg:w-[calc(50%-20px)]">
//                  <label htmlFor="city" className="block mb-1 text-white">City*</label>
//                  <input
//                    type="text"
//                    name="addressDto.city"
//                    id="city"
//                    value={formData.addressDto.city}
//                    onChange={handleChange}
//                    placeholder="City"
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    maxLength={50}
//                    readOnly
//                  />
//                  {errors.city && (
//                    <span className="text-white font-semibold text-base text-center block mt-1">{errors.city}</span>
//                  )}
//                </div>

//                <div className="w-full lg:w-[calc(50%-20px)]">
//                  <label htmlFor="zipCode" className="block mb-1 text-white">Zip Code*</label>
//                  <input
//                    type="text"
//                    name="addressDto.zipCode"
//                    id="zipCode"
//                    value={displayValue(formData.addressDto.zipCode)}
//                    onChange={handleChange}
//                    placeholder="Zip Code"
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    maxLength={10}
//                    onKeyPress={handleKeyPress}
//                    readOnly
//                  />
//                  {errors.zipCode && (
//                    <span className="text-white font-semibold text-base text-center block mt-1">{errors.zipCode}</span>
//                  )}
//                </div>
//              </div>

//              <div className="w-[85%] mx-auto flex flex-wrap items-start gap-5 py-2.5">
//                <div className="w-full lg:w-[calc(100%-20px)] mb-2.5">
//                  <input
//                    type="checkbox"
//                    id="acceptTerms"
//                    className="hidden"
//                    checked={acceptTerms}
//                    onChange={() => setAcceptTerms(!acceptTerms)}
//                  />
//                  <label
//                    htmlFor="acceptTerms"
//                    className="relative pl-7 cursor-pointer text-white before:content-[''] before:absolute before:left-0 before:top-0 before:w-5 before:h-5 before:border before:border-gray-300 before:rounded before:bg-white after:content-['✓'] after:font-bold after:text-base after:absolute after:top-0.5 after:left-0.5 after:text-blue-800"
//                    style={{
//                      '&::after': { display: acceptTerms ? 'block' : 'none' }
//                    }}
//                  >
//                    <Link to="" className="text-white no-underline">Terms of Use, Privacy Policy, Terms & Conditions</Link>
//                  </label>
//                  {errors.acceptTerms && (
//                    <span className="text-white font-semibold text-base text-center block mt-1">{errors.acceptTerms}</span>
//                  )}
//                </div>

//                <div className="w-full lg:w-[calc(100%-20px)]">
//                  <div className="flex items-center">
//                    <div className="flex items-center gap-2.5">
//                      <div className="flex-1 rounded-md p-2.5 flex justify-center items-center">
//                        <div className="w-[150px] text-lg font-bold text-gray-800 rounded-md">
//                          <p className="w-full tracking-wider flex justify-center items-center text-xl font-semibold text-gray-800 m-0">
//                            {generatedCaptcha}
//                          </p>
//                        </div>
//                      </div>

//                      <div className="max-w-[50px] text-center cursor-pointer text-lg text-white bg-blue-800 p-2.5 rounded-md shadow-[rgba(50,50,93,0.25)_0px_50px_100px_-20px,rgba(0,0,0,0.3)_0px_30px_60px_-30px]">
//                        <FontAwesomeIcon
//                          icon={faSync}
//                          onClick={regenerateCaptcha}
//                          className="refresh-icon"
//                        />
//                      </div>

//                      <div className="w-full flex-1 border-none rounded-md text-lg">
//                        <input
//                          maxLength={6}
//                          type="text"
//                          value={userInput}
//                          onChange={handleInputChange}
//                          placeholder="Enter Captcha"
//                          className="w-full border-none p-2.5 outline-none text-base bg-white text-black rounded-md focus:border-blue-800"
//                        />
//                        {errors.captcha && (
//                          <span className="text-white font-semibold text-base text-center block mt-1">{errors.captcha}</span>
//                        )}
//                      </div>
//                    </div>
//                  </div>
//                </div>
//              </div>

//              <div className="flex justify-end items-center pr-5 gap-2.5 flex-col sm:flex-col md:flex-row">
//                <button
//                  className="text-center bg-blue-800 text-white text-lg font-bold cursor-pointer border-none rounded-md py-4 px-16"
//                  type="button"
//                  onClick={handleCancel}
//                >
//                  Cancel
//                </button>
//                <button
//                  className="text-center bg-white text-blue-800 text-lg font-bold cursor-pointer border-none rounded-md py-4 px-16"
//                  type="submit"
//                >
//                  Confirm
//                </button>
//              </div>
//            </form>
//          </div>
//        </div>
//      )}
//      <div className="hoa-footer-import">
//        <HoaFooter />
//      </div>
//    </>
//  );
//}

//export default MemberOnboard;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";
import HoaNavbar from "../HoaNavbar/HoaNavbar";
import HoaFooter from "../HoaFooter/HoaFooter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync, faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import { API_URL } from '../../apiConfig';
import LoadingComman from '../Loading/LoadingCommon';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

function MemberOnboard() {
    const [selectedCountryId, setSelectedCountryId] = useState(0);
    const [loadingComman, setLoadingComman] = useState(false);
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [formData, setFormData] = useState({
        addressDto: {
            activeStatus: true,
            address: "",
            addressId: 0,
            city: "",
            countryId: 0,
            stateId: 0,
            zipCode: 0
        },
        boardMemberRole: "",
        clientDto: {
            activestatus: true,
            clientid: 0,
            communityid: 0,
            displayname: "",
            numberofhouses: 0,
            userid: 0
        },
        communityCode: "",
        contractCode: "",
        userDto: {
            activeStatus: false,
            emailId: "",
            emailIdIsVerified: true,
            firstName: "",
            isClient: true,
            lastLogin: "",
            lastName: "",
            middleName: "",
            mobileIsVerified: true,
            mobileNumber: "",
            otp: 0,
            password: "",
            roleId: 1003,
            userId: 0,
            createdDate: new Date().toISOString(),
            modifiedById: null,
            modifiedDate: new Date().toISOString(),
            userProfileUrl: ""
        }
    });

    const handlePhoneNumberChange = (value) => {
        setFormData((prevState) => ({
            ...prevState,
            userDto: {
                ...prevState.userDto,
                mobileNumber: value,
            },
        }));

        // Clear the phone number error when user starts typing
        setErrors((prevErrors) => ({
            ...prevErrors,
            mobileNumber: value ? "" : prevErrors.mobileNumber,
        }));
    };

    const [communityCode, setCommunityCode] = useState("");
    const [communityAddressData, setCommunityAddressData] = useState(null);
    console.log(communityAddressData);

    const handleCommunityCode = (e) => {
        const newCommunityCode = e.target.value;
        setCommunityCode(newCommunityCode);
        setFormData((prevFormData) => ({
            ...prevFormData,
            communityCode: newCommunityCode,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            communityCode: newCommunityCode ? "" : prevErrors.communityCode,
        }));
    };

    useEffect(() => {
        if (communityCode) {
            fetchcommunityAddressData(communityCode);
        }
    }, [communityCode]);

    const fetchcommunityAddressData = async (communityCode) => {
        try {
            const response = await fetch(`${API_URL}/public/community/getByCommunityCodeForUser/${communityCode}`);
            if (response.ok) {
                const data = await response.json();
                setCommunityAddressData(data);
                const addressFormDataUpdate = {
                    addressDto: {
                        activeStatus: true,
                        address: "",
                        addressId: 0,
                        city: data.city,
                        countryId: data.countryId,
                        stateId: data.stateId,
                        zipCode: data.zipCode
                    }
                };
                setSelectedCountryId(data.countryId);
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    addressDto: addressFormDataUpdate.addressDto,
                }));
            } else {
                console.error('Failed to fetch Community Address data');
            }
        } catch (error) {
            console.error('Error fetching Community Address  data:', error);
        }
    };

    const [errors, setErrors] = useState({});
    const [verified, setVerified] = useState(false);
    const [captchaValid, setCaptchaValid] = useState(false);
    const [userInput, setUserInput] = useState("");
    const [mathQuestion, setMathQuestion] = useState(generateMathCaptcha());
    const [captchaErrorMessage, setCaptchaErrorMessage] = useState(null);
    const [countryData, setCountryData] = useState([]);
    const [stateData, setStateData] = useState([]);

    useEffect(() => {
        axios.get(`${API_URL}/public/country/getAll`)
            .then(response => {
                setCountryData(response.data);
            })
            .catch(error => {
                console.error('Error fetching countries:', error);
            });
    }, []);

    useEffect(() => {
        axios.get(`${API_URL}/public/state/getAll`)
            .then(response => {
                setStateData(response.data);
            })
            .catch(error => {
                console.error('Error fetching states:', error);
            });
    }, []);

    useEffect(() => {
        setFormData(prevState => ({
            ...prevState,
            clientDto: {
                ...prevState.clientDto,
                displayname: prevState.userDto.firstName
            }
        }));
    }, [formData.userDto.firstName]);

    function generateMathCaptcha() {
        const num1 = Math.floor(Math.random() * 20) + 1;
        const num2 = Math.floor(Math.random() * 20) + 1;
        const operators = ['+', '-', '×'];
        const operator = operators[Math.floor(Math.random() * operators.length)];

        let answer;
        let question;

        switch (operator) {
            case '+':
                answer = num1 + num2;
                question = `${num1} + ${num2}`;
                break;
            case '-':
                // Ensure positive result
                const larger = Math.max(num1, num2);
                const smaller = Math.min(num1, num2);
                answer = larger - smaller;
                question = `${larger} - ${smaller}`;
                break;
            case '×':
                const smallNum1 = Math.floor(Math.random() * 10) + 1;
                const smallNum2 = Math.floor(Math.random() * 10) + 1;
                answer = smallNum1 * smallNum2;
                question = `${smallNum1} × ${smallNum2}`;
                break;
            default:
                answer = num1 + num2;
                question = `${num1} + ${num2}`;
        }

        return { question, answer: answer.toString() };
    }

    function handleInputChange(event) {
        const value = event.target.value;
        setUserInput(value);

        // Clear the captcha error when user starts typing
        setErrors((prevErrors) => ({
            ...prevErrors,
            captcha: value ? "" : prevErrors.captcha,
        }));
    }

    function regenerateCaptcha() {
        setMathQuestion(generateMathCaptcha());
        setUserInput("");
    }

    const validateForm = async () => {
        let isValid = true;
        const newErrors = {};

        // First Name validation
        if (!formData.userDto.firstName || !formData.userDto.firstName.trim()) {
            newErrors.firstName = "Please provide your first name.";
            isValid = false;
        }

        // Last Name validation
        if (!formData.userDto.lastName || !formData.userDto.lastName.trim()) {
            newErrors.lastName = "Please provide your last name.";
            isValid = false;
        }

        // Email validation
        if (!formData.userDto.emailId || !formData.userDto.emailId.trim()) {
            newErrors.emailId = "Please provide your email address.";
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(formData.userDto.emailId)) {
            newErrors.emailId = "Please provide a valid email address.";
            isValid = false;
        } else {
            const emailId = formData.userDto.emailId;
            const isEmailAvailable = await handleEmailCheck(emailId);

            if (!isEmailAvailable) {
            } else {
                newErrors.emailId = 'Email is already taken';
                isValid = false;
            }
        }

        // Residential address validation
        if (!formData.addressDto.address || !formData.addressDto.address.trim()) {
            newErrors.address = "Please provide your residential address.";
            isValid = false;
        }

        // Country validation
        if (!formData.addressDto.countryId) {
            newErrors.countryId = "Please select your country name.";
            isValid = false;
        }

        // State validation
        if (!formData.addressDto.stateId) {
            newErrors.stateId = "Please select your state name.";
            isValid = false;
        }

        // Mobile number validation
        if (
            !formData.userDto.mobileNumber ||
            formData.userDto.mobileNumber.length < 10 ||
            !/^\d+$/.test(formData.userDto.mobileNumber)
        ) {
            newErrors.mobileNumber = "Please enter a valid phone number.";
            isValid = false;
        }

        // City validation
        if (!formData.addressDto.city || !formData.addressDto.city.trim()) {
            newErrors.city = "Please provide your city.";
            isValid = false;
        }

        // Zip code validation
        if (!formData.addressDto.zipCode || !String(formData.addressDto.zipCode).trim()) {
            newErrors.zipCode = "Please provide your zip code.";
            isValid = false;
        }

        // Community code validation
        if (!formData.communityCode || !formData.communityCode.trim()) {
            newErrors.communityCode = "Please provide a valid CommunityCode.";
            isValid = false;
        } else if (/[)( _+":;'.,]/.test(formData.communityCode)) {
            newErrors.communityCode = "CommunityCode cannot contain spaces or invalid characters.";
            isValid = false;
        }

        // Captcha validation
        if (!userInput) {
            newErrors.captcha = "Please solve the math problem.";
            isValid = false;
        } else if (userInput !== mathQuestion.answer) {
            newErrors.captcha = "Incorrect answer. Please try again.";
            isValid = false;
        }

        // Terms and conditions validation
        if (!acceptTerms) {
            newErrors.acceptTerms = "You must accept the terms and conditions.";
            isValid = false;
        }

        // Set the validation errors to state
        setErrors(newErrors);
        console.log(newErrors);

        // Return true if there are no errors (all validations passed), false otherwise
        return isValid;
    };

    const handleEmailCheck = async (emailId) => {
        console.log("Checking email availability...");

        try {
            const response = await axios.get(`${API_URL}/user/check/email?emailId=${emailId} `);
            if (response.status === 200) {
                return false;
            }
            return true;
        } catch (error) {
            console.error('Error checking email:', error);
            return true;
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prevState => {
            const updatedFormData = { ...prevState };

            const fieldPath = name.split('.');
            if (fieldPath.length === 2) {
                const [section, field] = fieldPath;
                updatedFormData[section][field] = (field === 'countryId' || field === 'stateId') ? parseInt(value, 10) : value;
            } else {
                updatedFormData[name] = value;
            }

            return updatedFormData;
        });

        setErrors(prevErrors => {
            const updatedErrors = { ...prevErrors };

            const errorKey = name.split('.').pop();

            if (updatedErrors[errorKey]) {
                delete updatedErrors[errorKey];
            }

            return updatedErrors;
        });

        if (name === 'addressDto.countryId') {
            setSelectedCountryId(parseInt(value, 10));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);

        const isValid = await validateForm();

        if (isValid) {
            setLoadingComman(true);
            try {
                const response = await axios.post(`${API_URL}/public/clientRequest/add`, formData);
                console.log('Form submitted successfully:', response.data);
                setFormData({});
                alert("Registered Successfully");
                handleCancel();
                window.location.href = '/';
            } catch (error) {
                console.error('Error submitting form:', error);
            } finally {
                setLoadingComman(false);
            }
        } else {
            setLoadingComman(false);
        }
    };

    const handleKeyPress = (e) => {
        if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
        }
    };

    const displayValue = (value) => {
        return value === 0 ? "" : value;
    };

    const handleCancel = () => {
        setFormData({
            addressDto: {
                activeStatus: true,
                address: "",
                addressId: 0,
                city: "",
                countryId: 0,
                stateId: 0,
                zipCode: 0
            },
            clientDto: {
                activeStatus: true,
                clientid: 0,
                communityid: 0,
                displayname: "",
                numberofhouses: 0,
                userid: 0
            },
            communityCode: "",
            contractCode: "",
            userDto: {
                activeStatus: false,
                emailId: "",
                emailIdIsVerified: true,
                firstName: "",
                isClient: true,
                lastLogin: "",
                lastName: "",
                middleName: "",
                mobileIsVerified: true,
                mobileNumber: "",
                otp: 0,
                password: "",
                roleId: 1003,
                userId: 0,
                createdDate: new Date().toISOString(),
                modifiedById: null,
                modifiedDate: new Date().toISOString(),
                userProfileUrl: ""
            }
        });
        setErrors({});
        setUserInput("");
        setAcceptTerms(false);
        //regenerateCaptcha();
    };

    return (
        <>
            <div className="fixed top-0 w-full z-50">
                <HoaNavbar />
            </div>
            {loadingComman && <LoadingComman />}
            {!loadingComman && (
                <div className="mt-[70px] min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-8 px-4">
                    <div className="max-w-7xl mx-auto">
                        <div className="bg-gradient-to-br from-blue-800 to-blue-900 text-white shadow-2xl rounded-2xl overflow-hidden">
                            {/* Header Section */}
                            <div className="px-6 sm:px-8 lg:px-12 py-8 border-b border-blue-700/30">
                                <div className="flex items-center gap-4 mb-6">
                                    <div className="p-3 bg-white/10 rounded-xl backdrop-blur-sm">
                                        <FontAwesomeIcon icon={faShieldAlt} className="w-6 h-6 text-white" />
                                    </div>
                                    <div>
                                        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2">Client Registration</h1>
                                        <p className="text-blue-100 text-lg">Join our community by providing your information below</p>
                                    </div>
                                </div>
                                <div className="flex items-center gap-2 text-sm text-blue-200">
                                    <span className="w-2 h-2 bg-red-400 rounded-full animate-pulse"></span>
                                    Required fields are marked with an asterisk (*)
                                </div>
                            </div>

                            {/* Form Section */}
                            <div className="px-6 sm:px-8 lg:px-12 py-8">
                                <form onSubmit={handleSubmit} className="space-y-8">
                                    {/* Community Code Section */}
                                    <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
                                        <h3 className="text-xl font-semibold mb-4 text-white">Community Information</h3>
                                        <div className="max-w-md">
                                            <label htmlFor="communityCode" className="block mb-2 text-sm font-medium text-blue-100">
                                                Community Code *
                                            </label>
                                            <input
                                                type="text"
                                                name="communityCode"
                                                id="communityCode"
                                                value={communityCode}
                                                onChange={handleCommunityCode}
                                                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                placeholder="Enter community code"
                                            />
                                            {errors.communityCode && (
                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                    {errors.communityCode}
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Personal Information Section */}
                                    <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
                                        <h3 className="text-xl font-semibold mb-6 text-white">Personal Information</h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                            <div>
                                                <label htmlFor="firstName" className="block mb-2 text-sm font-medium text-blue-100">
                                                    First Name *
                                                </label>
                                                <input
                                                    type="text"
                                                    name="userDto.firstName"
                                                    id="firstName"
                                                    placeholder="Enter first name"
                                                    value={formData.userDto.firstName}
                                                    onChange={handleChange}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                    maxLength={50}
                                                />
                                                {errors.firstName && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.firstName}
                                                    </p>
                                                )}
                                            </div>

                                            <div>
                                                <label htmlFor="middleName" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Middle Name
                                                </label>
                                                <input
                                                    type="text"
                                                    name="userDto.middleName"
                                                    id="middleName"
                                                    placeholder="Enter middle name (optional)"
                                                    value={formData.userDto.middleName}
                                                    onChange={handleChange}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                    maxLength={50}
                                                />
                                            </div>

                                            <div>
                                                <label htmlFor="lastName" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Last Name *
                                                </label>
                                                <input
                                                    type="text"
                                                    name="userDto.lastName"
                                                    id="lastName"
                                                    placeholder="Enter last name"
                                                    value={formData.userDto.lastName}
                                                    onChange={handleChange}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                    maxLength={50}
                                                />
                                                {errors.lastName && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.lastName}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Contact Information Section */}
                                    <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
                                        <h3 className="text-xl font-semibold mb-6 text-white">Contact Information</h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            <div>
                                                <label htmlFor="mobileNumber" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Phone Number *
                                                </label>
                                                <PhoneInput
                                                    placeholder="Enter phone number"
                                                    value={formData.userDto.mobileNumber}
                                                    onChange={handlePhoneNumberChange}
                                                    defaultCountry="US"
                                                    containerClass="w-full"
                                                    inputClass="phone-input-custom"
                                                    country={'us'}
                                                    inputStyle={{
                                                        width: '100%',
                                                        height: '48px',
                                                        fontSize: '16px',
                                                        borderRadius: '12px',
                                                        border: '1px solid #d1d5db',
                                                        outline: 'none',
                                                        backgroundColor: 'white',
                                                        color: '#111827',
                                                        paddingLeft: '60px'
                                                    }}
                                                    buttonStyle={{
                                                        borderRadius: '12px 0 0 12px',
                                                        border: '1px solid #d1d5db',
                                                        backgroundColor: 'white'
                                                    }}
                                                />
                                                {errors.mobileNumber && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.mobileNumber}
                                                    </p>
                                                )}
                                            </div>

                                            <div>
                                                <label htmlFor="emailId" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Email Address *
                                                </label>
                                                <input
                                                    type="email"
                                                    name="userDto.emailId"
                                                    id="emailId"
                                                    placeholder="Enter email address"
                                                    value={formData.userDto.emailId}
                                                    onChange={handleChange}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                    maxLength={100}
                                                />
                                                {errors.emailId && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.emailId}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Address Information Section */}
                                    <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
                                        <h3 className="text-xl font-semibold mb-6 text-white">Address Information</h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            <div className="md:col-span-2">
                                                <label htmlFor="address" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Residential Address *
                                                </label>
                                                <input
                                                    type="text"
                                                    name="addressDto.address"
                                                    id="address"
                                                    placeholder="Enter your residential address"
                                                    value={formData.addressDto.address}
                                                    onChange={handleChange}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                    maxLength={100}
                                                />
                                                {errors.address && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.address}
                                                    </p>
                                                )}
                                            </div>

                                            <div>
                                                <label htmlFor="countryId" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Country *
                                                </label>
                                                <select
                                                    id="countryId"
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none"
                                                    name="addressDto.countryId"
                                                    value={formData.addressDto.countryId}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Select Country</option>
                                                    {countryData?.map(country => (
                                                        <option key={country.countryid} value={country.countryid}>
                                                            {country.countryname}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.countryId && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.countryId}
                                                    </p>
                                                )}
                                            </div>

                                            <div>
                                                <label htmlFor="stateId" className="block mb-2 text-sm font-medium text-blue-100">
                                                    State *
                                                </label>
                                                <select
                                                    id="stateId"
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none"
                                                    name="addressDto.stateId"
                                                    value={formData.addressDto.stateId}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Select State</option>
                                                    {stateData
                                                        .filter(state => state.countryid === selectedCountryId)
                                                        .map(state => (
                                                            <option key={state.stateid} value={state.stateid}>
                                                                {state.statename}
                                                            </option>
                                                        ))}
                                                </select>
                                                {errors.stateId && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.stateId}
                                                    </p>
                                                )}
                                            </div>

                                            <div>
                                                <label htmlFor="city" className="block mb-2 text-sm font-medium text-blue-100">
                                                    City *
                                                </label>
                                                <input
                                                    type="text"
                                                    name="addressDto.city"
                                                    id="city"
                                                    value={formData.addressDto.city}
                                                    onChange={handleChange}
                                                    placeholder="City"
                                                    className="w-full px-4 py-3 bg-gray-100 border border-gray-200 rounded-xl text-gray-700 placeholder-gray-500 transition-all duration-200 shadow-sm cursor-not-allowed"
                                                    maxLength={50}
                                                    readOnly
                                                />
                                                {errors.city && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.city}
                                                    </p>
                                                )}
                                            </div>

                                            <div>
                                                <label htmlFor="zipCode" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Zip Code *
                                                </label>
                                                <input
                                                    type="text"
                                                    name="addressDto.zipCode"
                                                    id="zipCode"
                                                    value={displayValue(formData.addressDto.zipCode)}
                                                    onChange={handleChange}
                                                    placeholder="Zip Code"
                                                    className="w-full px-4 py-3 bg-gray-100 border border-gray-200 rounded-xl text-gray-700 placeholder-gray-500 transition-all duration-200 shadow-sm cursor-not-allowed"
                                                    maxLength={10}
                                                    onKeyPress={handleKeyPress}
                                                    readOnly
                                                />
                                                {errors.zipCode && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.zipCode}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Security & Terms Section */}
                                    <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
                                        <h3 className="text-xl font-semibold mb-6 text-white">Security Verification</h3>

                                        {/* Enhanced Captcha */}
                                        <div className="mb-6">
                                            <label className="block mb-3 text-sm font-medium text-blue-100">
                                                Please solve this math problem *
                                            </label>
                                            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                                                <div className="flex items-center gap-3">
                                                    <div className="bg-gradient-to-br from-blue-600 to-blue-700 px-6 py-4 rounded-xl border-2 border-blue-500/30 shadow-lg">
                                                        <span className="text-2xl font-bold text-white font-mono tracking-wider">
                                                            {mathQuestion.question} = ?
                                                        </span>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={regenerateCaptcha}
                                                        className="p-3 bg-white/10 hover:bg-white/20 rounded-xl transition-all duration-200 border border-white/20 hover:border-white/40"
                                                        title="Generate new problem"
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faSync}
                                                            className="w-4 h-4 text-white hover:rotate-180 transition-transform duration-300"
                                                        />
                                                    </button>
                                                </div>
                                                <div className="flex-1 max-w-xs">
                                                    <input
                                                        type="text"
                                                        value={userInput}
                                                        onChange={handleInputChange}
                                                        placeholder="Your answer"
                                                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm text-center font-semibold"
                                                        maxLength={6}
                                                    />
                                                </div>
                                            </div>
                                            {errors.captcha && (
                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                    {errors.captcha}
                                                </p>
                                            )}
                                        </div>

                                        {/* Terms and Conditions */}
                                        <div className="space-y-4">
                                            <div className="flex items-start gap-3">
                                                <div className="flex items-center h-6">
                                                    <input
                                                        type="checkbox"
                                                        id="acceptTerms"
                                                        className="w-5 h-5 text-blue-600 bg-white border-2 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 transition-all duration-200"
                                                        checked={acceptTerms}
                                                        onChange={() => setAcceptTerms(!acceptTerms)}
                                                    />
                                                </div>
                                                <label htmlFor="acceptTerms" className="text-sm text-blue-100 leading-relaxed">
                                                    I agree to the{' '}
                                                    <Link
                                                        to="#"
                                                        className="text-white underline hover:text-blue-200 transition-colors duration-200 font-medium"
                                                    >
                                                        Terms of Use
                                                    </Link>
                                                    ,{' '}
                                                    <Link
                                                        to="#"
                                                        className="text-white underline hover:text-blue-200 transition-colors duration-200 font-medium"
                                                    >
                                                        Privacy Policy
                                                    </Link>
                                                    , and{' '}
                                                    <Link
                                                        to="#"
                                                        className="text-white underline hover:text-blue-200 transition-colors duration-200 font-medium"
                                                    >
                                                        Terms & Conditions
                                                    </Link>
                                                </label>
                                            </div>
                                            {errors.acceptTerms && (
                                                <p className="text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                    {errors.acceptTerms}
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Form Actions */}
                                    <div className="flex flex-col sm:flex-row gap-4 justify-end pt-6 border-t border-white/10">
                                        <button
                                            type="button"
                                            onClick={handleCancel}
                                            className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-xl transition-all duration-200 border border-white/20 hover:border-white/40 hover:scale-105 transform"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="px-8 py-3 bg-white hover:bg-gray-100 text-blue-800 font-semibold rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105 transform border border-white"
                                        >
                                            Complete Registration
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="hoa-footer-import">
                <HoaFooter />
            </div>
        </>
    );
}

export default MemberOnboard;